// import Vue from "vue";

const state = {
  inputOptions: {
    col: 24,
    label: "Input框",
    labelWidth: 4,
    value: "",
    type: "text",
    clearable: false,
    disabled: false,
    prefixIcon: null,
    suffixIcon: null,
    placeholder: "",
    requireMsg: "",
    require: false,
    reg: "",
    regMsg: ""
  },
  selectOptions: {
    col: 24,
    label: "Select框",
    labelWidth: 4,
    value: "",
    multiple: false,
    clearable: false,
    filterable: false,
    disabled: false,
    placeholder: "",
    optionsType: true,
    optionsArray: ['选项1', '选项2', '选项3'],
    optionsZd: "",
    requireMsg: "",
    require: false
  },
  sliderOptions: {
    col: 24,
    label: "Slider滑块",
    labelWidth: 4,

    value: 0,
    min: 0,
    max: 24,
    step: 1,
    showInput: false,
    showInputControls: true,
    inputSize: "default",
    showStops: false,
    showTooltip: true,
    range: false,
    vertical: false,
    height: "120",
    disabled: false,
    marks: {}
  },
  radioOptions: {
    col: 24,
    label: "单选框",
    labelWidth: 4,
    value: '请于表单工作区完善表单选项',
    multiple: false,
    clearable: false,
    filterable: false,
    disabled: false,
    placeholder: "",
    optionsType: true,
    optionsArray: ['请于表单工作区完善表单选项'],
    optionsZd: "",
    requireMsg: "",
    require: false,
    reg: "",
    regMsg: ""
  },
  timeOptions: {
    col: 24,
    label: "日期时间选择器",
    labelWidth: 6,
    value: "",
    multiple: false,
    clearable: false,
    filterable: false,
    disabled: false,
    placeholder: "",
    optionsType: true,
    require: false,
    timeType: "date",
    valueType: ""
  },
  switchOptions: {
    col: 24,
    label: "开关",
    labelWidth: 4,
    value: "",
    width: 40,
    activeIconClass: "",
    inactiveIconClass: "",
    activeText: "",
    inactiveText: "",
    activeValue: true,
    inactiveValue: false,
    activeColor: "#409EFF",
    inactiveColor: "#C0CCDA",
    name: "",
    validateEvent: true,
    optionsZd: "",
    requireMsg: "",
    require: false,
    reg: "",
    regMsg: ""
  },
  checkBoxOptions: {
    col: 24,
    label: "多选框",
    labelWidth: 4,
    value: ['选项1', '选项2'],
    multiple: false,
    clearable: false,
    filterable: false,
    disabled: false,
    placeholder: "",
    optionsType: true,
    optionsArray: ['选项1', '选项2', '选项3'],
    optionsZd: "",
    requireMsg: "",
    require: false,
    reg: "",
    regMsg: ""
  },
  formBox: {

    "type": "formBox",
    "name": "表单",
    "icon": "icon-m-gundongwenzi",
    "form_mark": "签到",
    "form_title": "签到",
    "button_text": "签到",
    "background_image": 1,
    "background_image_path": "https://www.cndmcloud.com/storage/file/2024-08/cssMtfjzQwbDZvCTjfHGhjtBE5NOa6rYwBKk7CCo.pdf",
    "options": {
      "type": "formBox",
      "form_type": 2,
      "data": {
        "menuArr": [{
            "name": "Inpute",
            "type": "inputWork",
            "label": "单行文本",
            "icon": "account-book",
            "sort": 1,
            "options": {
              "typeof": "input",
              "col": 24,
              "label": "姓名",
              "labelWidth": 200,
              "value": null,
              "type": "text",
              "clearable": false,
              "disabled": false,
              "prefixIcon": null,
              "suffixIcon": null,
              "placeholder": "请填写真实姓名",
              "requireMsg": null,
              "require": false,
              "reg": null,
              "regMsg": null
            }
          },
          {
            "name": "Selecte",
            "type": "selectWork",
            "label": "下拉框",
            "icon": "deployment-unit",
            "sort": 2,
            "options": {
              "typeof": "select",
              "col": 24,
              "label": "性别",
              "labelWidth": 200,
              "multiple": false,
              "clearable": false,
              "filterable": false,
              "disabled": false,
              "placeholder": "请选择",
              "optionsType": true,
              "optionsArray": [
                "男",
                "女", 
              ],
              "optionsZd": null,
              "requireMsg": null,
              "require": false
            }
          },
          {
            "name": "Inpute",
            "type": "inputWork",
            "label": "单行文本",
            "icon": "account-book",
            "sort": 3,
            "options": {
              "typeof": "input",
              "col": 24,
              "label": "医院",
              "labelWidth": 200,
              "value": null,
              "type": "text",
              "clearable": false,
              "disabled": false,
              "prefixIcon": null,
              "suffixIcon": null,
              "placeholder": "请填写医院名称",
              "requireMsg": null,
              "require": false,
              "reg": null,
              "regMsg": null
            }
          },
          {
            "name": "Inpute",
            "type": "inputWork",
            "label": "单行文本",
            "icon": "account-book",
            "sort": 4,
            "options": {
              "typeof": "input",
              "col": 24,
              "label": "科室",
              "labelWidth": 200,
              "value": null,
              "type": "text",
              "clearable": false,
              "disabled": false,
              "prefixIcon": null,
              "suffixIcon": null,
              "placeholder": "请填写所在科室",
              "requireMsg": null,
              "require": false,
              "reg": null,
              "regMsg": null
            }
          },
          {
            "name": "Selecte",
            "type": "selectWork",
            "label": "下拉框",
            "icon": "deployment-unit",
            "sort": 5,
            "options": {
              "typeof": "select",
              "col": 24,
              "label": "职称",
              "labelWidth": 200,
              "multiple": false,
              "clearable": false,
              "filterable": false,
              "disabled": false,
              "placeholder": "请选择职称",
              "optionsType": true,
              "optionsArray": [
                "主任医师",
                "副主任医师",
                "主治医师",
                "住院医师",
                "医师",
                "其他"
              ],
              "optionsZd": null,
              "requireMsg": null,
              "require": false
            }
          }
        ],
        "pageCss": {
          "page_css_margin": "0px 0px 0px 0px",
          "page_css_padding": "24px 24px 24px 24px",
          "page_css_interval": 5,
          "page_css_radius": 0,
          "page_css_bgc": "#ffffff",
          "textBgc": "rgba(255,255,255,1)",
          "myCss": null,
          "loginName": "签到",
          "loginBtn": "131"
        }
      }
    }
  },
  formwork: []

};

const mutations = {
  SET_FORMWORK(state, params) {
    console.log(params)
    params.arr ?
      state.formwork.splice(params.index, params.num, params.arr) :
      state.formwork.splice(params.index, params.num);
  },
  SET_FORMWORKOBH(state, params) {
    state.formwork[params.index].options[params.label] = params.value;
  }
};

const actions = {
  SET_FORMWORKFUN({
    commit
  }, params) {
    commit("SET_FORMWORK", params);
  },
  SET_FORMWORKOBHFUN({
    commit
  }, params) {
    commit("SET_FORMWORKOBH", params);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};